import Grid from "@material-ui/core/Grid";
import * as React from "react";

import Container from "./Container";
import CustomerGroupFilter from "./CustomerGroups/CustomerGroupFilter";
import CustomerGroupList from "./CustomerGroups/CustomerGroupList";
import CustomerGroupResult from "./CustomerGroups/CustomerGroupResult";
import MapSelection from "./MapSelection";

class Geoselection extends React.Component {
  public render() {
    return (
      <Container>
        <Grid container={true} spacing={2}>
          <Grid item={true} xs={12}>
            <CustomerGroupList />
          </Grid>
          <Grid item={true} xs={12}>
            <CustomerGroupFilter expanded={false} />
          </Grid>
          <Grid item={true} xs={12}>
            <MapSelection />
          </Grid>
          <Grid item={true} xs={12}>
            <CustomerGroupResult />
          </Grid>
        </Grid>
      </Container>
    );
  }
}

export default Geoselection;



// WEBPACK FOOTER //
// ./src/components/Geoselection.tsx